import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SliderMapCvComponent} from '../slider-map-cv/slider-map-cv.component';
import { JobsOffersApplicant } from '../../models/jobs-offers-applicant';
import { Constants } from '../constants';

@Component({
  selector: 'app-item-candidate-map',
  templateUrl: './item-candidate-map.component.html',
  styleUrls: ['./item-candidate-map.component.css']
})
export class ItemCandidateMapComponent implements OnInit {
  @Input() user;
  @Input() index;
  @Input() filters;

  selectedOption;

  public STATUS = Constants;

  constructor(public dialog: MdDialog) {
  }

  ngOnInit() {
  }

  openCV(userId){
    let dialogRef = this.dialog.open(SliderMapCvComponent, {
      data: {selected:userId, map:true, filters: this.filters}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidate-map/item-candidate-map.component.ts